import { Plantilla } from "./Plantilla";

export class TNmTipoNotificacion {
    mostrarmodal: string;
    urlabrir: string;
    segmento: string;
    urlverificacionestadoobjeto: string;
    pagina: string;
    urlimagen: string;
    idnmtiponotificacion: number;
    idsistema: number;
    descripcion: string;
    Titulo: string;
    plantillatextoenviar: string;
    ultimoCambio: Date;
    mostrarappnotificacion: string;
    urlparadatosplantilla: string;
    estado: string;
    tNmCampania: string[];
  
    constructor(
      mostrarmodal: string,
      urlabrir: string,
      segmento: string,
      urlverificacionestadoobjeto: string,
      pagina: string,
      urlimagen: string,
      idnmtiponotificacion: number,
      idsistema: number,
      descripcion: string,
      titulo: string,
      plantillatextoenviar: string,
      ultimoCambio: Date,
      mostrarappnotificacion: string,
      urlparadatosplantilla: string,
      estado: string,
      tNmCampania: string[]
    ) {
      this.mostrarmodal = mostrarmodal;
      this.urlabrir = urlabrir;
      this.segmento = segmento;
      this.urlverificacionestadoobjeto = urlverificacionestadoobjeto;
      this.pagina = pagina;
      this.urlimagen = urlimagen;
      this.idnmtiponotificacion = idnmtiponotificacion;
      this.idsistema = idsistema;
      this.descripcion = descripcion;
      this.Titulo = titulo;
      this.plantillatextoenviar = plantillatextoenviar;
      this.ultimoCambio = new Date(ultimoCambio);
      this.mostrarappnotificacion = mostrarappnotificacion;
      this.urlparadatosplantilla = urlparadatosplantilla;
      this.estado = estado;
      this.tNmCampania = tNmCampania;
    }

    static ConstruirPorPlantilla(
      plantilla: Plantilla
    ) {
      return new TNmTipoNotificacion(
        plantilla.mostraModal ? "S" : "N",
        plantilla.urlWeb,
        "",
        plantilla.urlVerificacion ?? "",
        plantilla.paginaDestino,
        plantilla.urlImagen ?? "",
        Number(plantilla.id!),
        plantilla.idSistema === null ?  29 : plantilla.idSistema === "0" ? 29 : Number(plantilla.idSistema),
        plantilla.descripcion,
        plantilla.titulo,
        plantilla.contenido,
        plantilla.ultimoCambio !== '' ? new Date(plantilla.ultimoCambio) : new Date(),
        plantilla.mostrarAppNotificacion ??  "N",
        plantilla.urlRecuperacion ?? "",
        plantilla.estado ? "A" : "I",
        []
      );
      
    }
  }
  